import React from 'react';
import SupplierCard from './SupplierCard';
import SupplierListItem from './SupplierListItem';
import SupplierCardWithMatch from './SupplierCardWithMatch';
import SupplierListItemWithMatch from './SupplierListItemWithMatch';
import SearchSkeleton from './SearchSkeleton';

function SearchResults({ data, isLoading, viewMode = 'list', showFilters, rfqId }) {
  if (isLoading) {
    return <SearchSkeleton />;
  }

  const hasResults = data.pages.some((page) =>
    page.suppliers.some(
      (supplier) => supplier.logo_url && supplier.logo_url.trim() !== ''
    )
  );

  // Helper function to check if any filters are applied
  const hasActiveFilters = () => {
    const searchParams = new URLSearchParams(window.location.search);
    return (
      searchParams.get('categories') ||
      searchParams.get('country') ||
      searchParams.get('services') ||
      searchParams.get('moq_range') ||
      searchParams.get('specialties')
    );
  };

  // Clear all filters function
  const clearAllFilters = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const query = searchParams.get('q') || '';
    
    // Keep only the search query parameter
    window.location.href = query ? `/search?q=${encodeURIComponent(query)}` : '/search';
  };

  if (!hasResults) {
    return (
      <div className="my-6 has-text-centered">
        <p className="mb-2">No suppliers found matching your criteria.</p>
        <p className="has-text-grey mb-4">
          Try adjusting your search terms or filters to find more results.
        </p>
        {hasActiveFilters() && (
          <button 
            className="button is-primary is-small"
            onClick={clearAllFilters}
          >
            Remove all filters
          </button>
        )}
      </div>
    );
  }

  return (
    <div
      className={viewMode === 'grid' ? 'columns is-mobile is-multiline' : ''}
    >
      {data.pages.map((page, i) => (
        <React.Fragment key={`page-${i}`}>
          {page.suppliers.map(
            (supplier) =>
              supplier.logo_url &&
              supplier.logo_url.trim() !== '' && (
                <div
                  key={supplier.shortcode}
                  className={
                    viewMode === 'grid'
                      ? `column is-full-mobile is-one-third-tablet ${
                          rfqId
                            ? 'is-one-fifth-desktop'
                            : showFilters
                            ? 'is-one-quarter-desktop'
                            : 'is-one-quarter-desktop'
                        }`
                      : 'mb-4'
                  }
                >
                  {viewMode === 'grid' ? (
                    supplier.match ? (
                      <SupplierCardWithMatch {...supplier} />
                    ) : (
                      <SupplierCard {...supplier} />
                    )
                  ) : (
                    supplier.match ? (
                      <SupplierListItemWithMatch {...supplier} />
                    ) : (
                      <SupplierListItem {...supplier} />
                    )
                  )}
                </div>
              )
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default SearchResults;
